<vex-page-layout>
  <vex-page-layout-header class="pb-4" fxLayout="column" fxLayoutAlign="center start">
    <!--        <div class='w-full flex flex-col sm:flex-row justify-between container'>-->
    <!--            <div>-->
    <!--                <h1 class='title mt-0 mb-1'>Etablissement</h1>-->
    <!--                <vex-breadcrumbs [crumbs]="['Etablissement']"></vex-breadcrumbs>-->
    <!--            </div>-->
    <!--        </div>-->
  </vex-page-layout-header>

  <vex-page-layout-content class="-mt-6">
    <div class="card overflow-auto -mt-16">
      <base-data-table-header
        label="Établissement(s)"
        [loading]="loading"
        [showArchives]="canShowArchivePermissions"
        [showSynchronization]="true"
        (onSearchChange)="onSearchChange($event)"
        (onShowArchived)="onShowArchived($event)"
        (onClearTextFilter)="clearTextFilter()"
        (onSynchronization)="onSynchronization($event)"
        (onCreate)="createItem()"
        [canImport]="true"
        (onImport)="importItem()"
        [createPermission]="[ENUM_PERMISSIONS.CREATE_ESTABLISHMENT]"
        [importPermission]="[ENUM_PERMISSIONS.CREATE_ESTABLISHMENT]"
        [exportPermission]="[ENUM_PERMISSIONS.READ_ESTABLISHMENT]"
        [synchronizePermission]="[ENUM_PERMISSIONS.READ_ESTABLISHMENT]"
        [canCreate]="canCreatePermissions"
      ></base-data-table-header>

      <base-data-table
        [count]="count"
        [pageSize]="pageSize"
        [pageIndex]="pageIndex"
        [sortField]="sortField"
        [sortOrder]="sortOrder"
        [dataSource]="dataSource"
        [displayedColumns]="displayedColumns"
        [feisColumns]="feisColumns"
        [stickyTop]="true"
        (onPageEvent)="pageEvent($event)"
        (onSortEvent)="sortEvent($event)"
        (onUpdateItem)="updateItem($event)"
        (onDeleteItem)="deleteItem($event)"
        (onArchiveItem)="archiveItem($event)"
        [routerLinkDetailRow]="routerLinkDetailRow"
      ></base-data-table>
    </div>
  </vex-page-layout-content>
</vex-page-layout>
